module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/overhear/4.png?bbd454541bc99328369ef309ee822013";